import React from 'react'
import { ReactComponent as Icon } from 'assets/menuWide/settings.svg'

export default function SettingsIcon(props: any) {
  return (
    <Icon {...props} />
  )
}